module.exports = __webpack_public_path__ + "static/img/active2.6b34dcb4.png";